import * as IoC from 'typescript-ioc';
import { JobConfiguration } from '../../job-configuration';
import { JobType } from '../../../../api/jobs.dao';
import { IMeetingsDAO } from '../../../../api/meetings.dao';

export class MeetingsRemoveJob extends JobConfiguration {
    public readonly type = JobType.MeetingsRemoving;
    public readonly name = 'Bulk Remove Meetings';
    public readonly description = 'Removing Meetings';

    public async execute(execParams) {
        return IoC.Container.get(IMeetingsDAO).removeMeetingsByStartDateTimes(execParams);
    }
}

export default {
    [JobType.MeetingsRemoving]: MeetingsRemoveJob
};
